import "../../mission/MissionsFilters.scss";
import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import { FormattedMessage } from "react-intl";
import { FILTERS_FOR_NAMES, QUERY_STATUS, TAG_TYPES } from "constants/constants";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import Icon from "core/icon/Icon";
import { useContext, useEffect, useState } from "react";
import "moment/locale/fr";
import InfoContext from "pages/InfoContext";
import CategoryTag from "core/tags/category-tag/CategoryTag";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import NoNesultIcon from "assets/icons/no-result.svg";
import { getStatusLabel } from "utils/workerHelper";
import { getFormattedDate } from "utils/functions";
import PropTypes from "prop-types";
import {
  renderInitialLoaderOrNoResult,
  sortHandler,
  sortTriggerHelper,
} from "utils/toolsManagerHelper";

const CsltStrByFilters = ({ missionsList, getTimeline, filters }) => {
  const { timelineQueryStatus, lang } = useContext(InfoContext);
  const { getNamesByFilters } = useGeneralContext();

  useEffect(() => {
    const ids = missionsList?.map((elm) => elm?.manager_id).filter(Boolean);
    if (ids?.length) {
      getNamesByFilters({
        types: [FILTERS_FOR_NAMES.PERSON],
        id: ids,
        include_deleted: true,
      });
    }
  }, [missionsList]);

  const [sort, setSort] = useState({
    "mission-name": "asc",
    "client-name": "asc",
    "manager-name": "asc",
    "start-date": "asc",
    "end-date": "asc",
  });
  const createSortableLabel = (id, defaultMessage, sortKey) => ({
    key: id,
    value: (
      <>
        <FormattedMessage id={id} defaultMessage={defaultMessage} />
        <Icon
          icon={sortTriggerHelper({
            header: sort?.[sortKey],
            sortCondition: "desc",
          })}
          color="gray-200"
          width={20}
          height={20}
          onClick={() =>
            sortHandler({
              sortKey,
              currentSort: sort?.[sortKey],
              setSort,
              getter: getTimeline,
              filters: { type: "cslt_str", id: filters[0]?.value },
            })
          }
        />
      </>
    ),
  });

  const header = [
    {
      label: createSortableLabel(
        "mission_title",
        "Intitulé de la mission",
        "mission-name"
      ),
      icon: "missions",
      iconWidth: 20,
      iconHeight: 20,
      id: "mission_title",
    },

    {
      label: createSortableLabel("client", "Client", "client-name"),
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "client",
    },
    {
      label: {
        key: "manager",
        value: <FormattedMessage id="manager" defaultMessage={"Manager"} />,
      },
      icon: "user",
      iconWidth: 20,
      iconHeight: 20,
      id: "manager",
    },
    {
      label: createSortableLabel("start_date", "Date de début", "start-date"),
      icon: "calendar",
      iconWidth: 20,
      iconHeight: 20,
      id: "start_date",
    },

    {
      label: createSortableLabel("end_date", "Date de fin", "end-date"),
      icon: "calendar",
      iconWidth: 20,
      iconHeight: 20,
      id: "end_date",
    },
    {
      label: {
        key: "status",
        value: <FormattedMessage id="status" defaultMessage={"Statut"} />,
      },
      icon: "loading",
      minWidth: "fit-content",
      id: "status",
    },
  ];

  const content = (missionsToDisplay) =>
    missionsToDisplay?.map((elem) => ({
      name: elem.mission_name || "-",
      client: elem.client_name || "-",
      manager: elem.manager_name ? (
        <CategoryTag
          key={1}
          type={TAG_TYPES.PEOPLE}
          label={elem.manager_name || "-"}
          showing={true}
          many={false}
          deleteOption={false}
          linkValue={elem.manager_id}
        />
      ) : (
        "-"
      ),
      start_date: getFormattedDate(elem.start_date, lang) || "-",
      end_date: getFormattedDate(elem.end_date, lang) || "-",
      status: getStatusLabel(elem.worker_status) || "-",
    }));

  return (
    <div className="section">
      <ScrollToTop />
      <div>
        {renderInitialLoaderOrNoResult({
          status:
            timelineQueryStatus === QUERY_STATUS.LOADING &&
            QUERY_STATUS.LOADING,
          hasContent: missionsList?.length,
        })}
        {missionsList?.length === 0 &&
          timelineQueryStatus === QUERY_STATUS.SUCCESS && (
            <div className="no-result-wrapper">
              <img
                src={NoNesultIcon}
                alt="no-result-icon"
                className="no-result-icon"
              />
              <p className="title-4 violet no-result-text">
                <FormattedMessage
                  id="no_results"
                  defaultMessage="Oops, aucun résultat pour cette recherche."
                />
              </p>
            </div>
          )}
        {missionsList.length > 0 && (
          <>
            <div className="results">
              <div className="title">
                <Typography
                  className="title-3 violet text-uppercase"
                  CsltStrByFilters
                  type="h2"
                  label={
                    <FormattedMessage id="results" defaultMessage="Résultats" />
                  }
                />
                <div className="total">: {missionsList?.length}</div>
              </div>
            </div>
            <div>
              <Table
                id={`missions-by-filters`}
                header={header}
                content={content(missionsList) || []}
                tableWidth={"100%"}
                toolsManagerMission={true}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

CsltStrByFilters.propTypes = {
  missionsList: PropTypes.array,
  getTimeline: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
  })),
};

export default CsltStrByFilters;
